var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("business")]),
          _vm._v(" " + _vm._s(_vm.$t("log.title")))
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _vm.logsType == "database" || _vm.logsType === ""
                ? _c("crud-table", {
                    attrs: {
                      headers: _vm.headers,
                      url: _vm.url,
                      filters: _vm.filters,
                      order: _vm.order,
                      graphql: _vm.graphql,
                      "data-graphql": _vm.dataGraphql,
                      showFilter: true
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "items",
                          fn: function(items) {
                            return [
                              _c(
                                "td",
                                [
                                  items.item.nivel == "ERROR"
                                    ? _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            label: "",
                                            color: "error",
                                            "text-color": "white"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(items.item.nivel) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  items.item.nivel == "ADVERTENCIA"
                                    ? _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            label: "",
                                            color: "warning",
                                            "text-color": "white"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(items.item.nivel) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  items.item.nivel == "INFO"
                                    ? _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            label: "",
                                            color: "info",
                                            "text-color": "white"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(items.item.nivel) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(items.item.tipo))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(items.item.mensaje))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(items.item.referencia))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(items.item.ip))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$datetime.format(
                                      items.item.fecha,
                                      "dd/MM/YYYY hrs. HH:mm"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(items.item.usuario))])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      948642257
                    )
                  })
                : _c("crud-table", {
                    attrs: {
                      headers: _vm.headers,
                      url: "system/" + _vm.url + "/listar",
                      filters: _vm.filters,
                      order: _vm.order,
                      showFilter: true
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "items",
                        fn: function(items) {
                          return [
                            _c(
                              "td",
                              [
                                items.item.nivel == "ERROR"
                                  ? _c(
                                      "v-chip",
                                      {
                                        attrs: {
                                          label: "",
                                          color: "error",
                                          "text-color": "white"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(items.item.nivel) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                items.item.nivel == "ADVERTENCIA"
                                  ? _c(
                                      "v-chip",
                                      {
                                        attrs: {
                                          label: "",
                                          color: "warning",
                                          "text-color": "white"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(items.item.nivel) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                items.item.nivel == "INFO"
                                  ? _c(
                                      "v-chip",
                                      {
                                        attrs: {
                                          label: "",
                                          color: "info",
                                          "text-color": "white"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(items.item.nivel) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(items.item.tipo))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(items.item.mensaje))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(items.item.referencia))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(items.item.ip))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.$datetime.format(
                                    items.item.fecha,
                                    "dd/MM/YYYY hrs. HH:mm"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(items.item.usuario))])
                          ]
                        }
                      }
                    ])
                  })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47097af8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47097af8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Log.vue
// module id = null
// module chunks = 